import classNames from 'classnames'
import React, { FC } from 'react'
import * as css from './SelectWrapper.css'

export interface SelectWrapperProps {
  isScrollable?: boolean
}

const SelectWrapper: FC<SelectWrapperProps> = ({ isScrollable = true, children }) => {
  return <div className={classNames({ [css['wrapper']]: isScrollable })}>{children}</div>
}

export default SelectWrapper
